import React from 'react';
import { Container } from 'react-bootstrap';
import AppHeader from '../../components/Common/AppHeader';
import AppFooter from '../../components/Common/AppFooter';

const AIEthicsPolicy = () => (
  <div className="bg-light min-vh-100 d-flex flex-column">
    <AppHeader />
    <Container className="py-5 flex-grow-1 bg-white shadow-sm my-5 rounded p-5">
      <h2 className="fw-bold">AI Ethics & Responsible Use Policy</h2>
      <hr />

      <section className="mb-4">
        <h4>1. Purpose</h4>
        <p>AcademicOS is an assistive academic system and not an autonomous decision-maker.</p>
      </section>

      <section className="mb-4">
        <h4>2. Human-in-the-Loop</h4>
        <p>All AI outputs must be reviewed by qualified experts. AI does not replace academic judgment.</p>
      </section>

      <section className="mb-4">
        <h4>3. Accuracy & Limitations</h4>
        <p>AI-generated content may contain inaccuracies and must be validated before use.</p>
      </section>

      <section className="mb-4">
        <h4>4. Academic Integrity</h4>
        <p>Users must ensure originality, proper citation, and avoid plagiarism.</p>
      </section>

      <section className="mb-4">
        <h4>5. Bias & Fairness</h4>
        <p>Outputs should be reviewed for bias and contextual appropriateness.</p>
      </section>

      <section className="mb-4">
        <h4>6. Prohibited Use</h4>
        <ul>
          <li>No fraudulent or misleading academic content</li>
          <li>No misuse of AI outputs</li>
        </ul>
      </section>

      <section className="mb-4">
        <h4>7. Intellectual Property</h4>
        <p>Users are responsible for lawful use of uploaded and generated content.</p>
      </section>

    </Container>
    <AppFooter />
  </div>
);
export default AIEthicsPolicy
